import moment from "moment";
import {
  LABEL_JOB,
  LABEL_JOB_DETAILS,
  LABEL_JOB_STATUS,
} from "../../../constant/label_constant";
import { openSignUrl } from "../../../utils/HelperFunction";

const DetailRow = ({ icon, label, children }) => (
  <div className="booking-overview__row">
    <i className={`booking-overview__row-icon ${icon}`} aria-hidden="true" />
    <div>
      <span className="booking-overview__label">{label}</span>
      <div className="booking-overview__value">{children || "—"}</div>
    </div>
  </div>
);

const BasicDetailsTab = ({ bookingData }) => {
  const customer = bookingData.user_detail || {};
  const serviceCenter = bookingData.service_centre || {};
  const serviceContact = serviceCenter.poc_details || {};
  const appliance = bookingData.appliance || {};
  const sourceChannel = bookingData.source_channel || {};
  const formatDate = (date) =>
    date ? moment(date).format("DD MMM YYYY") : "—";
  const customerAddress = [
    bookingData.booking_address,
    bookingData.booking_city,
    bookingData.booking_state,
  ]
    .filter(Boolean)
    .join(", ");
  const serviceAddress = [
    serviceCenter.address,
    serviceCenter.city,
    serviceCenter.pincode && `Pincode: ${serviceCenter.pincode}`,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <section className="booking-overview">
      <div className="booking-overview__hero">
        <div>
          <span className="booking-overview__eyebrow">{LABEL_JOB_DETAILS}</span>
          <h2>{bookingData.booking_id || "Booking"}</h2>
          <p>Order ID: {bookingData.order_id || "—"}</p>
        </div>
        <div className="booking-overview__hero-actions">
          <span className="booking-overview__status">
            {bookingData.current_status || "Status unavailable"}
          </span>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            disabled={!bookingData.jobcard_file}
            onClick={() =>
              bookingData.jobcard_file && openSignUrl(bookingData.jobcard_file)
            }
          >
            <i className="fas fa-download" aria-hidden="true" />
            {bookingData.jobcard_file
              ? "Download job card"
              : "Job card unavailable"}
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-7 d-flex">
          <article className="booking-overview__panel booking-overview__panel--customer">
            <div className="booking-overview__panel-title">
              <i className="fas fa-user" aria-hidden="true" /> Customer
            </div>
            <h3>{customer.customer_name || "—"}</h3>
            <div className="booking-overview__details">
              <DetailRow icon="fas fa-phone" label="Phone">
                {[
                  bookingData.booking_primary_mobile_number,
                  bookingData.booking_alternate_mobile_number,
                ]
                  .filter(Boolean)
                  .join(" / ")}
              </DetailRow>
              <DetailRow icon="fas fa-envelope" label="Email">
                {customer.user_email}
              </DetailRow>
              <DetailRow icon="fas fa-location-dot" label="Address">
                {customerAddress}
                {bookingData.booking_pincode &&
                  `${customerAddress ? ", " : ""}Pincode: ${bookingData.booking_pincode}`}
              </DetailRow>
            </div>
          </article>
        </div>
        <div className="col-lg-5 d-flex">
          <article className="booking-overview__panel">
            <div className="booking-overview__panel-title">
              <i className="fas fa-screwdriver-wrench" aria-hidden="true" />{" "}
              {LABEL_JOB_DETAILS}
            </div>
            <div className="booking-overview__details">
              <DetailRow icon="fas fa-box" label="Appliance">
                {appliance.appliance_name}
              </DetailRow>
              <DetailRow icon="fas fa-tag" label="Booking type">
                {bookingData.booking_type}
              </DetailRow>
              <DetailRow icon="fas fa-store" label="Seller channel">
                {sourceChannel.source}
              </DetailRow>
              <DetailRow icon="fas fa-indian-rupee-sign" label="Due / paid">
                ₹ {Math.round(bookingData.amount_due || 0)} / ₹{" "}
                {Math.round(bookingData.amount_paid || 0)}
              </DetailRow>
            </div>
          </article>
        </div>
        <div className="col-md-6 d-flex">
          <article className="booking-overview__panel">
            <div className="booking-overview__panel-title">
              <i className="fas fa-building" aria-hidden="true" /> Assigned
              service center
            </div>
            <h3>{serviceCenter.display_name || "Not assigned"}</h3>
            <div className="booking-overview__details">
              <DetailRow icon="fas fa-user" label="Point of contact">
                {serviceContact.name}
              </DetailRow>
              <DetailRow icon="fas fa-phone" label="Phone">
                {serviceContact.mobile_number}
              </DetailRow>
              <DetailRow icon="fas fa-location-dot" label="Address">
                {serviceAddress}
              </DetailRow>
            </div>
          </article>
        </div>
        <div className="col-md-6 d-flex">
          <article className="booking-overview__panel">
            <div className="booking-overview__panel-title">
              <i className="fas fa-calendar-days" aria-hidden="true" /> Schedule
            </div>
            <div className="booking-overview__details booking-overview__details--two-column">
              <DetailRow icon="fas fa-calendar-plus" label="Registered">
                {formatDate(bookingData.createdAt)}
              </DetailRow>
              <DetailRow icon="fas fa-calendar-day" label="Booking date">
                {formatDate(bookingData.booking_date)}
              </DetailRow>
              <DetailRow
                icon="fas fa-calendar-day"
                label={`First ${LABEL_JOB}`}
              >
                {formatDate(bookingData.booking_initial_date)}
              </DetailRow>
              <DetailRow icon="fas fa-calendar-check" label="Appointment">
                {formatDate(bookingData.booking_booking_date)}
              </DetailRow>
              <DetailRow icon="fas fa-calendar-check" label="SC closed">
                {formatDate(bookingData.sc_closed_date)}
              </DetailRow>
              <DetailRow icon="fas fa-calendar-xmark" label="Closed">
                {formatDate(bookingData.closed_date)}
              </DetailRow>
            </div>
          </article>
        </div>
        <div className="col-md-6 d-flex">
          <article className="booking-overview__panel">
            <div className="booking-overview__panel-title">
              <i className="fas fa-circle-info" aria-hidden="true" />{" "}
              {LABEL_JOB_STATUS}
            </div>
            <div className="booking-overview__details">
              <DetailRow icon="fas fa-circle" label="Current status">
                {bookingData.current_status}
              </DetailRow>
              <DetailRow icon="fas fa-circle" label="Partner status">
                {bookingData.partner_current_status}
              </DetailRow>
              <DetailRow icon="fas fa-circle" label="Internal status">
                {bookingData.partner_internal_status}
              </DetailRow>
            </div>
          </article>
        </div>
        <div className="col-md-6 d-flex">
          <article className="booking-overview__panel">
            <div className="booking-overview__panel-title">
              <i className="fas fa-star" aria-hidden="true" /> Ratings & remarks
            </div>
            <div className="booking-overview__details">
              <DetailRow icon="fas fa-star" label="SC rating">
                {bookingData.asc_rating
                  ? `${bookingData.asc_rating}/5`
                  : "Not rated"}
              </DetailRow>
              <DetailRow icon="fas fa-star" label="AD rating">
                {bookingData.ad_rating
                  ? `${bookingData.ad_rating}/5`
                  : "Not rated"}
              </DetailRow>
              <DetailRow icon="fas fa-comment" label="Creation remarks">
                {bookingData.remarks}
              </DetailRow>
              <DetailRow icon="fas fa-comment" label="Closing remarks">
                {[
                  bookingData.admin_closing_remarks,
                  bookingData.sc_closing_remarks,
                ]
                  .filter(Boolean)
                  .join(" / ")}
              </DetailRow>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default BasicDetailsTab;
